import {Action} from "redux";

import {
    SearchCustomerListByClientRequest
} from "../request/scout_request";

import {
    SearchCustomerListByClientResponse
} from "../response/scout_response";

export enum ClientScoutCustomerListActionType {
    REQUEST_SEARCH_CUSTOMER_LIST = "CLIENT_SCOUT_REQUEST_SEARCH_CUSTOMER_LIST",
    CALLBACK_SEARCH_CUSTOMER_LIST = "CLIENT_SCOUT_CALLBACK_SEARCH_CUSTOMER_LIST",

}

export interface IRequestSearchCustomerListAction extends Action {
    type: ClientScoutCustomerListActionType.REQUEST_SEARCH_CUSTOMER_LIST;
    item: SearchCustomerListByClientRequest;
}

export interface ICallbackSearchCustomerListAction extends Action {
    type: ClientScoutCustomerListActionType.CALLBACK_SEARCH_CUSTOMER_LIST;
    isSuccess: boolean;
    item?: SearchCustomerListByClientResponse;
}

export type ClientScoutCustomerListAction =
    IRequestSearchCustomerListAction |
    ICallbackSearchCustomerListAction ;

export interface IClientScoutCustomerListActionCreator {

    requestSearchCustomerListAction(item: SearchCustomerListByClientRequest): IRequestSearchCustomerListAction;

    callbackSearchCustomerListAction(
        isSuccess: boolean,
        items?: SearchCustomerListByClientResponse,
    ): ICallbackSearchCustomerListAction;
}

class ActionCreator implements IClientScoutCustomerListActionCreator {

    public requestSearchCustomerListAction = (item: SearchCustomerListByClientRequest): IRequestSearchCustomerListAction => {
        return {
            type: ClientScoutCustomerListActionType.REQUEST_SEARCH_CUSTOMER_LIST,
            item,
        };
    };

    public callbackSearchCustomerListAction = (
        isSuccess: boolean,
        item?: SearchCustomerListByClientResponse,
    ): ICallbackSearchCustomerListAction => {
        return {
            type: ClientScoutCustomerListActionType.CALLBACK_SEARCH_CUSTOMER_LIST,
            isSuccess,
            item,
        };
    };
}

export const createClientScoutCustomerListActionCreator = (): IClientScoutCustomerListActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_scout_customers_action.ts